import React from 'react';

interface TransactionDetailFieldProps {
  label: string;
  value: React.ReactNode;
}

export function TransactionDetailField({ label, value }: TransactionDetailFieldProps) {
  if (value === null || value === undefined) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-1 py-2 border-b last:border-0">
      <span className="text-sm text-muted-foreground sm:w-48 shrink-0">{label}</span>
      <span className="text-sm font-medium">{value}</span>
    </div>
  );
}
